//const API = 'http://192.168.44.7:6001';
//const API = 'https://ziyichain.cn';
//const API = 'https://ziyichain.cn/miniapptest';
// const API = 'https://test.ziyichain.cn';
// console.log('网页可见区域高：' + document.body.clientHeight)
// console.log('网页可见区域宽：' + document.body.clientWidth)
const API =process.env.VUE_APP_BASE_API
let widthTab
let companyid = 0
refresh()
window.onresize = function() { //监听屏幕的改变
  setTimeout(function() {
    refresh();
  }, 10)
};
function refresh() {
  if (document.body.clientWidth > 1366) {
    widthTab = false
  } else {
    widthTab = true
  }
}
const edition = 'v5_0_8'; //当前版本号
//修改认证的公司信息
let usercompanyupdate = API + "/usercompanyupdate/"
// 识别图片
let ocr = API + "/ocr/"
//查看合同数据
let saleordercontract = API + "/saleordercontract/"
//成员产品管理页面删除接口
let spotproductdelete = API + "/spotproductdelete/"
//日汇款月汇款
let getCashAccountDetailTotal = API + "/getCashAccountDetailTotal/"
//资金账户充值记录展示
let checkcashaccountrecharge = API + "/checkcashaccountrecharge/"
//报价信息添加
let offeraskcreate = API + "/offeraskcreate/"
// 采购详情
let askdetails = API + "/askdetails/"
// 采购查询
let asktobuyview = API + "/asktobuyview/"
// 友商上传产品图片
let businessinputproduct = API + "/businessinputproduct/"
// 激活码发送短信接口
let activationcodesend = API + "/activationcodesend/"
// 修改激活码状态
let updateactivationcode = API + "/updateactivationcode/"
// 查询会员类别配置信息
let memberconfiguration = API + "/memberconfiguration/"
// 生成激活码
let createactivationcode = API + "/createactivationcode/"
// 删除广告详情
let updateadPlateinfo = API + "/updateadplateinfo/"
// 广告详情
let advplateinfo = API + "/advplateinfo/"
// 广告页的广告模块
let advplateKey = API + "/advplate/"
// 广告位下拉菜单数据
let advpage = API + "/advpage/"
// 删除产品图片
let backdelete = API + "/backstage/updateproductphoto/"
// 图片库
let backbrary = API + "/backstage/uploadfilelibrary/"
// 商品主图
let backphoto = API + "/backstage/addproductphoto/"
//积分类型
let creditchannel = API + "/creditchannel/"
// 积分明细
let appusercredit = API + "/appusercredit/"
// 查看订单相关总金额
let backstage = API + "/backstage/saleorderprices/"
// 查看订单凭证
let payorder = API + "/payorder/"
/* 登录 */
let LoginView = API + "/business/userlogin/"
let RegisterView = API + '/scmregister/'
/* 菜单 */
let UserPage = API + '/pages/'
/* 小益帮查 */
// 小益帮查记录
let database = API + '/index/'
let searchaction = API + '/searchaction/'
// 小益帮查搜索
let SearchDataView = API + '/webspider/searchdata/'
let SearchResult = API + '/postSearchResult/'
// 搜索模板
let searchmodel = API + "/searchmodel/"
// 审核注册信息
let CompanyRegisterCheckView = API + '/companyregistercheck/'
let CompanyRegister = API + '/companyregister/'


/* 用户展示 */
let DataShow = API + '/datashow/'
let userdata = API + '/userdata/'
let companystaff = API + '/business/companystaff/'
let userdatashow = API + "/userdatashow"
/* 权限 */
let pagepower = API + '/business/companyrole/'
// 部门
let department = API + '/business/department/'
// 上传凭证
let certificate = API + '/certificate/'
/*
  基本信息
 */
// 仓库
let warehouse = API + '/warehouse/'
// 产品信息
let product = API + '/product/'
// 其他基本信息
let option = API + '/option/'
/* 更新记录 */
let buglist = API + '/buglist/'
/*
  客户管理
 */
//客户录入
let customer = API + '/customer/'
// 客户审核
let customuser = API + '/customuser/'
let customUsershow = API + '/customusershow/'
/*
采购
 */
//新增采购订单
let procurementordershow = API + '/procurementordershow/'
let procurementorderupdate = API + '/procurementorderupdate/'
/*
 仓储管理
 */
// 待入库
let entry = API + '/entry/'
/*
销售单
 */
let spotproduct = API + '/spotproduct/'
let spotsale = API + '/business/spotsale/'
let saleorderdetails = API + '/business/saleorderdetails/'
// 销售请购单
let requidition = API + '/requidition/'
let requiditionshow = API + '/requiditionshow/'
// 查看订单评价
let appevaluation = API + '/appevaluation/'
// 出库单
let spotdelivery = API + '/spotdelivery/'
// 销售单出库信息导出
let downloadorderinfo = API + '/downloadorderinfo/'
// 小程序用户
let appusershow = API + '/appusershow/'
let appuser = API + '/appuser/'
// 银行号展示
let allocation = API + '/allocation/'
// 查看订单交易流水
let getOrderRecharge = API + '/getOrderRecharge/'
/*
 财务
 */
// 财务结算
let salefinal = API + '/salefinal/'
let salefinalshow = API + '/salefinalshow/'
let personnelpay = API + '/personnelpay/'
// 财务批准
let checksalefinal = API + '/checksalefinal/'
// 财务结算-下载excel表格
// 运费
let freight = API + '/freight/'
// 报表
let productreport = API + '/productreport/'
// 轮播图
let slidephoto = API + '/slidephoto/'
//孜益学院
let article = API + '/article/'
//获取验证码
let changebackstagepassword = API + '/v2/changebackstagepassword/'
//
let customization = API + '/customization/'
let financeprofit = API + '/financeprofit/'
let financebalance = API + '/financebalance/'
let profitcarry = API + '/profitcarry/'
let flowlist = API + '/flowlist/'
let fincertificate = API + '/fincertificate/'
let scmfile = API + '/scmfile/'
let producttoexcel = API + '/producttoexcel/'
let crmoldtonew = API + '/crmoldtonew/'
let datashow = API + '/datashow/'
let productupload = API + '/productupload/'
let collectcompany = API + '/collectcompany/'
let changewarehouse = API + '/changewarehouse/'
let userlogincount = API + '/userlogincount/'
let feedback = API + '/feedback/'
let customcompany = API + '/customcompany/'
// PC
let PCusershow = API + '/PCusershow/'
let apporderovertime = API + '/apporderovertime/'
let appusercollection = API + '/appusercollection/'
let shoppingcart = API + '/shoppingcart/'
let spotsaleinvoice = API + '/spotsaleinvoice/'
let uploadfile = API + '/uploadfile/'
let messagetemplate = API + '/messagetemplate/'
let messageshow = API + "/messageshow/"
let messagemanage = API + '/messagemanage/'
let businessproduct =API+'/businessproduct/'
let pcuserverif =API+'/pcuserverif/'
let wxspotsaleview=API+'/wxspotsaleview/'
let changeproductrank=API+'/changeproductrank/'
let updatesalestatus= API+'/updatesalestatus/'
// old 公司审核
let companyregistercheck = API+'/companyregistercheck/'
let updateScmCompany = API+'/updatescmcompany/'

// new 公司审核
let companycheck =API+'/companycheck/'
let fianacecheck =API +'/fianacecheck/'
const fillorderprice =API+'/fillorderprice/'
const saleorderversion =API +'/saleorderversion/'
  // 开票
const appuserinvoice=API+'/appuserinvoice/'
const productputaway =API+'/productputaway/'
const companyproducts =API+'/business/companyproducts/'
const custompublicpool =API+'/custompublicpool/'
const salescustomerlock =API+'/salescustomerlock/'
const mycustomers=API+'/mycustomers/'
const usercustomers=API+'/usercustomers/'
const companyoption=API+'/companyoption/'
// 小程序企业入驻
let usercompanycheck = API+'/usercompanycheck/'
const getScmInfo=API+'/business/getScmInfo/'
// 图片库分组
const getFilegroupview=API+'/filegroupview/v2/'
// 新建分组
const CreateGroup=API+'/filegroupview/v2/'
// 上传图片
const uploadPictures=API+'/uploadfileview/v2/'
// 展示分组下的图片
const showPictures=API+'/uploadfileview/v2/'
// 修改分组信息
const amendGroup=API+'/updatefilegroup/v2/'
// 修改图片信息
const amendPictures=API+'/updateimageview/v2/'
// 修改多个图片
const allPictures=API+'/delimagesinfo/v2/'
// 合同驳回
const rejectorderconstract=API+'/rejectorderconstract/'
// 小程序定价管理
const alterproductsaleprices=API+'/alterproductsaleprices/'

// 积分商城
// 添加商品分类
const createcreditcategory=API+'/createcreditcategory/'
// 修改商品分类
const updatecreditcategory=API+'/updatecreditcategory/'
// 展示商品列表
const creditgoods=API+'/creditgoods/'
// 展示商品详情
const creditgoodsdetails=API+'/creditgoodsdetails/'
// 获取订单列表
const creditorders=API+'/creditorders/'
// 获取订单明细
const usercreditorderlist=API+'/usercreditorderlist/'
// 商品上下架
const altercreditgoods=API+'/altercreditgoods/'
// 订单物流信息
const creditorderlogistics=API+'/creditorderlogistics/'
// 日志
// 搜索选项
const logsearchoptions=API+'/logsearchoptions/'
// 展示日志列表
const logsrecord=API+'/logsrecord/'
// 展示所有用户的加工单
const processorders=API+'/processorders/'
// 业务员接单
const takeprocessorder=API+'/takeprocessorder/'
// 新增加工单
const onlyprocessorder=API+'/onlyprocessorder/'
//修改加工单
const updateprocessorder=API+'/updateprocessorder/'
//展示单个加工
const singleprocessorder=API+'/singleprocessorder/'
//展示单个加工

// 展示菜单
const userlevelpages=API+'/v2/userlevelpages/'
// 添加快捷菜单
const usershortcutmenus=API+'/v2/usershortcutmenus/'
// 查看牌号 产品名
const productname=API+'/productname/'
// 小程序产品管理-修改产品基价、友商库存及删除
const productputaways=API+'/v2/productputaway/'
// 友商公司产品导出Excel
const exportbusinessproducts=API+'/v2/exportbusinessproducts/'
// Excel导入友商产品
const importbusinessproducts=API+'/v2/importbusinessproducts/'
// 创建邀请用户链接
const companyinvitestaff=API+'/business/companyinvitestaff/'





export {
  usercompanyupdate,//修改认证的公司信息
  ocr,//识别图片
  saleordercontract,//查看合同数据
  spotproductdelete,//成员产品管理页面删除接口
  getCashAccountDetailTotal,//日汇款月汇款
  checkcashaccountrecharge,//资金账户充值记录展示
  offeraskcreate,//报价信息添加
  askdetails,//采购详情
  asktobuyview,//采购查询
  businessinputproduct,//友商上传产品图片
  activationcodesend,//激活码发送短信接口
  updateactivationcode,//修改激活码状态
  memberconfiguration,//查询会员类别配置信息
  createactivationcode,//生成激活码
  updateadPlateinfo,// 删除广告详情
  advplateinfo,//广告详情
  advplateKey,// 广告页的广告模块
  advpage,// 广告位下拉菜单数据
  backdelete,  // 删除产品图片
  backbrary,//图片库
  backphoto,//商品主题
  creditchannel,//积分类型
  appusercredit, // 积分明细
  payorder , // 查看订单凭证
  backstage,// 查看订单相关总金额
  widthTab, //判断屏幕适配表格宽度
  edition, //版本
  LoginView, //登录
  RegisterView, //公司注册
  database,
  CompanyRegisterCheckView,
  CompanyRegister,
  SearchDataView,
  SearchResult,
  DataShow, //用户展示
  userdata, //用户信息
  companystaff, //用户信息
  UserPage, //菜单
  pagepower,
  searchaction,
  searchmodel,
  department,
  certificate,
  warehouse,
  product,
  option,
  buglist,
  customer,
  customuser,
  customUsershow,
  procurementorderupdate,
  entry,
  spotproduct,
  spotdelivery,
  downloadorderinfo,
  appusershow,
  userdatashow, //获取部门用户
  salefinal, //财务业务结算单
  salefinalshow, //财务结算录入
  requidition, //销售请购单
  requiditionshow, //销售请购单展示
  appevaluation, //查看订单评价
  freight, //地区运费
  spotsaleinvoice, //小程序开票
  personnelpay, //财务结算展示
  allocation, //银行卡号设置-
  productreport, //报表展示
  article, //孜益学院
  customization, //小程序申请请购
  financeprofit, //利润报表
  financebalance, //资产负载表,
  profitcarry, //财务结转
  flowlist, //现金流量表
  fincertificate, //展示应付/应收/现金流水
  scmfile, //文件管理
  producttoexcel, //现货和期货报表下载
  crmoldtonew, //客户关系文件导入
  datashow, //获取各公司账号
  productupload, //老系统产品数据导入
  collectcompany, //小益帮查文件下载
  changewarehouse, //现货产品转库功能
  userlogincount, //系统用户登录统计
  feedback, //反馈信息
  customcompany, //所有客户信息
  companyid,
  spotsale, //获取产品信息
  saleorderdetails, //展示订单明细
  appuser, //获取个信息
  PCusershow, //根据手机号进行登录 //修改pc端密码
  apporderovertime, //清除超时订单
  procurementordershow, //期货订单
  appusercollection, //加入购物车
  slidephoto, //轮播图
  shoppingcart, //加入购物车
  uploadfile, //申请开票
  // 信息模块
  messagetemplate,
  messageshow,
  messagemanage,
  businessproduct,//微信小程序上传文件
  pcuserverif,//PC修改密码 发送验证码
  wxspotsaleview,//合并产品信息
  changeproductrank,//管理产品排序
  updatesalestatus,
  companyregistercheck,//绑定企业认证r
  fianacecheck,//财务审核
  fillorderprice,//差价审核
  saleorderversion,//订单产品信息
  appuserinvoice,
  productputaway,
  companycheck,//new 公司审核,
  custompublicpool,//客户公共池,
  salescustomerlock,//销售人员客户绑定
  mycustomers,//我的客户
  usercustomers,//客户管理展示
  companyoption,
  usercompanycheck,
  updateScmCompany,//修改友商认证信息
  getScmInfo,//统计信息
  getFilegroupview, //图片库分组信息
  CreateGroup,//图片库创建
  uploadPictures,//上传图片
  showPictures, // 展示分组下的图片
  amendGroup, //修改分组信息
  amendPictures, //修改图片信息
  allPictures, //修改多个图片
  API,
  rejectorderconstract, // 合同驳回
  alterproductsaleprices, //小程序定价管理
  createcreditcategory, //添加商品分类
  updatecreditcategory, //修改商品分类
  creditgoods, //展示商品列表
  getOrderRecharge, // 查看订单交易流水
  creditgoodsdetails, //展示商品详情
  creditorders,   // 获取订单列表
  usercreditorderlist,   // 获取订单明细
  altercreditgoods, //商品上下架
  creditorderlogistics, //订单物流信息
  checksalefinal, //财务结算批准
  logsearchoptions, //搜索选项
  logsrecord, //展示日志列表
  processorders,//展示所有用户的加工单
  takeprocessorder,//业务员接单
  onlyprocessorder,//新增加工单
  updateprocessorder,//修改加工单
  singleprocessorder,//展示单个加工
  userlevelpages,//展示菜单
  usershortcutmenus,//添加快捷菜单
  productname,   // 查看牌号 产品名
  productputaways,   // 小程序产品管理-修改产品基价、友商库存及删除
  exportbusinessproducts, //友商公司产品导出Excel
  importbusinessproducts, //Excel导入友商产品
  companyinvitestaff,  //创建邀请用户链接
  companyproducts,
  changebackstagepassword,//获取验证码
}





//////////////////
// WEBPACK FOOTER
// ./static/API/API.js
// module id = nzox
// module chunks = 5